<template>
  <div class="top">
    <!--    这里注意设置轮播高度和图片高度一致-->
    <el-carousel
      :type="pageView == 1 ? 'card' : ''"
      :interval="during"
      :height="setHeight"
      :class="pageView == 1 ? 'setbg1' : 'setbg2'"
    >
      <el-carousel-item v-for="(item, index) in imgUrl" :key="index">
        <img class="big" :src="item.img" alt="" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: "Swiper",
  props: {
    imgUrl: {
      typeof: Array,
      default: () => [],
    },
    during: {
      typeof: String,
    },
    setHeight: "",
    pageView: "",
  },
  data() {
    return {
      carouselHeight: "700px",
      screenWidth: 0,
    };
  },
  created() {
    this.screenWidth = localStorage.getItem("screenWidth");
    this.updateCarouselHeight();
  },
  methods: {
    updateCarouselHeight() {
      if (this.screenWidth <= 768) {
        this.carouselHeight = "200px"; // Adjust the height as needed
      } else {
        // this.carouselHeight = '500px'; // Default height
      }
    },
  },
};
</script>

<style scoped>
.el-carousel__item {
  text-align: center;
  /* padding-top: 80px; */
}
/deep/ .el-carousel__mask{
  background: none !important;
}
.setbg1 {
  background: url("../../assets/swiperHome/007.png") no-repeat;
  background-size: cover;
  font-size: 24px;
}
.setbg2 {
  background: url("../../assets/swiperHome/010.png") no-repeat;
  background-size: cover;
  font-size: 24px;
}

.tips {
  margin-top: 20px;
  display: flex;
  height: 40px;
  font-weight: bold;
  justify-content: center;
  align-items: center;
}
.xiang {
  display: flex;
  height: 30px;
  justify-content: center;
  align-items: center;
}
.top .wei {
  position: relative;
}
.left-tips {
  position: absolute;
  top: 10%;
  left: 32%;
}
.line {
  display: flex;
  font-size: 15px;
  height: 23px;
  align-items: center;
}

.top .big {
  margin-top: 250px;
}
.top {
  width: 100%;
  /* height: 100%; */
}
</style>
